import React, {useEffect, useState} from "react";
import {FormHelperText, IconButton, InputLabel, List, MenuItem, Select} from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import {Close} from "@material-ui/icons";
import {MAKE, MODEL, required, TIRESIZE, TRIM, updateSearch, YEAR} from "../../../shared/constantsEN";
import FormControl from "@material-ui/core/FormControl";
import {useDispatch, useSelector} from "react-redux";
import {
    newTire,
    setMakes,
    setModels,
    setSelectMake,
    setSelectModel,
    setSelectSize,
    setSelectTrim,
    setSelectYear,
    setSizes,
    setTrims,
    updateResults,
    setFilterDialogFlag,
    setTireSizeDialogFlag,
} from "../../../core/redux/ActionCreator";
import yearMakeModelService from "../../../shared/services/yearMakeModelService";
import searchResultsService from "../../../shared/services/searchResultsService";

const AddNewTires= ()=>{
    const bac = useSelector(state => state.dealerReducer.bac);
    const clearData = [];
    const dispatch = useDispatch();
    const updateTire = useSelector(state => state.searchResultReducer.newTire);
    const tireSizeDialogOpen = useSelector(state => state.searchResultReducer.tireSizeDialogFlag);
    const makes = useSelector(state => state.yearMakeModelReducer.makes);
    const [make,setMake]=useState(useSelector(state => state.yearMakeModelReducer.sMake));
    const [makeError, setMakeError] = useState(false);
    const models = useSelector(state => state.yearMakeModelReducer.models);
    const [model,setModel]=useState(useSelector(state => state.yearMakeModelReducer.sModel));
    const [modelError, setModelError] = useState(false);
    const trims = useSelector(state => state.yearMakeModelReducer.trims);
    const [trim,setTrim]=useState(useSelector(state => state.yearMakeModelReducer.sTrim));
    const tireSizes = useSelector(state => state.yearMakeModelReducer.sizes);
    const [tireSize,setTireSize]=useState(useSelector(state => state.yearMakeModelReducer.sSize));
    const [tireSizeError, setTireSizeError] = useState(false);
    const [yearError, setYearError] = useState(false);
    const [year, setYear]= useState(useSelector(state => state.yearMakeModelReducer.sYear));
    const years = useSelector(state => state.yearMakeModelReducer.years);
    //let newYear, newMake, newTrim, newModel, newSize ='';

    useEffect(function getYMM(){
        if(makes.length === 0 && year !== '') {
            yearMakeModelService.getMakes(year);
        }
        if(models.length === 0 && year !== '' && make !== '') {
            yearMakeModelService.getModels(year,make);
        }
        if(trims.length === 0 && year !== '' && make !== '' && model !== ''){
            yearMakeModelService.getTrims(year,make,model);
            yearMakeModelService.getSizes(year,make,model,null);
        }
        if(tireSizes.length === 0 && year !== '' && make !== '' && model !== '') {
            yearMakeModelService.getSizes(year,make,model,trim);
        }

    }, [makes.length, year, models.length, make, trims.length, model, tireSizes.length, trim, ] );

    if(tireSizes.length ===1 && tireSize === ''&& model !==''){
        setTireSize(tireSizes[0]);
        setTireSizeError(false)
    }

    function changeYear() {
        dispatch(setMakes(clearData));
        dispatch(setModels(clearData));
        dispatch(setTrims(clearData));
        dispatch(setSizes(clearData));

        setTireSize('');
        setTrim('');
        setMake('');
        setModel('');
    }

    function handleYearClose(event) {
        if (event.target.textContent === undefined && year === ''){
            setYearError(true);
        }else if(event.target.textContent !== ''){
            setYear(event.target.textContent);
            setYearError(false);

            yearMakeModelService.getMakes(event.target.textContent)
        }
    }

    const yearDropdown = (
        <FormControl variant="outlined">
            <InputLabel className="dropdownLabel" id="year-dropdown-label" >
                {YEAR}
            </InputLabel>
            <Select
                className="year-dropdown"
                error={yearError}
                label={YEAR}
                labelId="year-dropdown-label"
                onChange={changeYear}
                onClose={handleYearClose}
                value={year}
                inputProps={{
                    "class": `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
                required
            >
                {years.map(item => (<MenuItem key={item} value={item}>{item}</MenuItem>))}
            </Select>
            {yearError && (<FormHelperText error>{required}</FormHelperText>)}
        </FormControl>
    );

    function changeMake() {
        setTireSize('');
        setTrim('');
        setModel('');

        dispatch(setModels(clearData));
        dispatch(setTrims(clearData));
        dispatch(setSizes(clearData));
    }

    function handleMakeClose(event) {
        if (event.target.textContent === undefined && make === ''){
            setMakeError(true);
        }else if(event.target.textContent !== ''){
            setMake(event.target.textContent);
            setMakeError(false);

            yearMakeModelService.getModels(year,event.target.textContent)
        }
    }

    const makeDropdown = (
        <FormControl variant="outlined">
            <InputLabel
                className="make-dropdown-label"
                disabled={!year}
                id="make-dropdown-label"
            >
                {MAKE}
            </InputLabel>
            <Select
                className="make-dropdown"
                error={makeError}
                label={MAKE}
                labelId="make-dropdown-label"
                onChange={changeMake}
                onClose={handleMakeClose}
                value={make}
                variant="outlined"
                disabled={!year}
                inputProps={{
                    "class": `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
                required
            >
                {makes.map(item => (
                    <MenuItem className="dropdown-group-element" key={item} value={item}>
                        {item}
                    </MenuItem>))}
            </Select>
            {makeError && (<FormHelperText error>{required}</FormHelperText>)}
        </FormControl>
    );

    function changeModel() {
        setTireSize('');
        setTrim('');

        dispatch(setTrims(clearData));
        dispatch(setSizes(clearData));
    }

    function handleModelClose(event) {
        if (event.target.textContent === undefined && make === ''){
            setModelError(true);
        }else if(event.target.textContent !== ''){
            setModel(event.target.textContent);
            setModelError(false);

            yearMakeModelService.getTrims(year,make,event.target.textContent);
            yearMakeModelService.getSizes(year,make,event.target.textContent, null);
        }
    }

    const modelDropdown = (
        <FormControl variant="outlined">
            <InputLabel
                className="model-dropdown-label"
                disabled={!make}
                id="model-dropdown-label"
            >
                {MODEL}
            </InputLabel>
            <Select
                className="model-dropdown"
                error={modelError}
                label={MODEL}
                labelId="model-dropdown-label"
                onChange={changeModel}
                onClose={handleModelClose}
                value={models.includes(model)?model:''}
                variant="outlined"
                disabled={!make}
                inputProps={{
                    "class": `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
                required
            >
                {models.map(item => (
                    <MenuItem className="dropdown-group-element" key={item} value={item}>
                        {item}
                    </MenuItem>))}
            </Select>
            {modelError && (<FormHelperText error>{required}</FormHelperText> )}
        </FormControl>
    );

    function trimChange(event) {
        setTrim(event.target.value);
        setTireSize('');
        dispatch(setSizes(clearData));

    }

    function handleTrimClose(event) {
        if (event.target.textContent !== undefined && make !== ''){
            setTrim(event.target.textContent);
            setTireSize('');
            yearMakeModelService.getSizes(year,make,model,event.target.textContent);
        }
    }

    const trimDropdown = (
        <FormControl variant="outlined">
            <InputLabel
                className="trim-dropdown-label"
                disabled={!model}
                id="model-dropdown-label"
            >
                {TRIM}
            </InputLabel>
            <Select
                className="trim-dropdown"
                label={TRIM}
                labelId="model-dropdown-label"
                onChange={trimChange}
                onClose={handleTrimClose}
                value={trims.includes(trim)?trim:''}
                variant="outlined"
                disabled={!model}
                inputProps={{
                    "class": `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
                required
            >
                {trims.map((item) => (
                    <MenuItem key={item} value={item}>
                        {item}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );

    function sizeChange(event) {
        setTireSize(event.target.value);
        if(trim === '')dispatch(setSelectTrim(null));
    }

    const sizeDropdown = (
        <FormControl variant="outlined">
            <InputLabel
                className="trim-dropdown-label"
                disabled={!model}
                id="model-dropdown-label"
            >
                {TIRESIZE}
            </InputLabel>
            <Select
                className="trim-dropdown"
                error={tireSizeError}
                label={TIRESIZE}
                labelId="size-dropdown-label"
                onChange={sizeChange}
                value={tireSizes.includes(tireSize)?tireSize:''}
                variant="outlined"
                disabled={!model}
                inputProps={{
                    "class": `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
                required
            >
                {tireSizes.map((item) => (
                    <MenuItem key={item} value={item}>
                        {item}
                    </MenuItem>
                ))}
            </Select>
            {tireSizeError && (
                <FormHelperText error>{required}</FormHelperText>
            )}
        </FormControl>
    );

    function openNewSearch() {
        dispatch(newTire({newTire:true}));
        dispatch(setFilterDialogFlag({filterDialogFlag: false}));
        dispatch(setTireSizeDialogFlag({tireSizeDialogFlag: true}));
    }

    function closeNewSearch () {
        dispatch(newTire({newTire:false}));
        dispatch(setTireSizeDialogFlag({tireSizeDialogFlag: false}));
    }

    function validateAndLoad() {
         if(year !== '' && make !== '' && model !== '' && tireSize !== ''){
             searchResultsService.getResults(tireSize, year, make, model, bac);
             dispatch(setSelectMake(make));
             dispatch(setSelectModel(model));
             dispatch(setSelectYear(year));
             dispatch(setSelectSize(tireSize));
             dispatch(setSelectTrim(trim));
             dispatch(newTire({newTire:false}));
             dispatch(updateResults({updateResult: true}));
         } else {
             if (year === '') setYearError(true);
             if (make === '') setMakeError(true);
             if (model === '') setModelError(true);
             if (tireSize === '') setTireSizeError(true);
             dispatch(newTire({newTire: true}));
         }
        dispatch(setTireSizeDialogFlag({tireSizeDialogFlag: false}));
    }

    return (
        <div className={'root'}>
            <button aria-label='new search' onClick={openNewSearch}
                    className="button primary-button stat-button-link" data-dtm="search results">
                Change Tire Size
            </button>
            <Drawer variant='persistent' anchor='left' open={updateTire && tireSizeDialogOpen} className={'drawer'}
                    classes={{paper: 'drawerPaper'}}>
                <div className={'drawerHeader'}>
                    <IconButton onClick={closeNewSearch}><Close/></IconButton>
                    <List>
                        <div className="yearMakeModelDisplay">
                            <div className='miniHeader'>{updateSearch}</div>
                            <br/>
                            <div className="miniHeader">
                                <div className={'spacer'}>{yearDropdown}</div>
                            </div>
                            <div className="miniHeader">
                                <div className={'spacer'}>{makeDropdown}</div>
                            </div>
                            <div className="miniHeader">
                                <div className={'spacer'}>{modelDropdown}</div>
                            </div>
                            <div className="miniHeader">
                                <div className={'spacer'}>{trimDropdown}</div>
                            </div>
                            <div className="miniHeader">
                                <div className={'spacer'}>{sizeDropdown}</div>
                            </div>
                        </div>
                        <button className="button primary-button stat-button-link" data-dtm={"search results"}
                                onClick={()=>validateAndLoad()}>UPDATE SEARCH
                        </button>
                    </List>
                </div>
            </Drawer>
        </div>
    );
};
export default AddNewTires
